import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { reducer } from './state/opti.reducer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { OptiEffects } from './state/opti.effects';
import { NgxPaginationModule } from 'ngx-pagination';

import { OptiShellComponent } from './containers/opti-shell/opti-shell.component';
import { OptiEditShellComponent } from './containers/opti-edit-shell/opti-edit-shell.component';
import { OptiProdShellComponent } from './containers/opti-prod-shell/opti-prod-shell.component';
import { OptiListComponent } from './components/opti-list/opti-list.component';
import { OptiEditComponent } from './components/opti-edit/opti-edit.component';
import { OptiProdComponent } from './components/opti-prod/opti-prod.component';
import { ProductionPlanningComponent } from './components/production-planning/production-planning.component';

// Módulo con elementos compartidos (service, directive, pipes, components, etc.).
import { SharingModule } from '../sharingModule/sharingModule.module';

// Módulo para la ordenación de tablas por columnas.
import { SortableColumnModule } from '../sortableColumn/sortableColumn.module';


@NgModule({
  declarations: [
    OptiShellComponent,
    OptiEditShellComponent,
    OptiProdShellComponent,
    OptiListComponent,
    OptiEditComponent,
    OptiProdComponent,
    ProductionPlanningComponent
  ],
  imports: [
    SharingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    StoreModule.forFeature('opti', reducer),
    EffectsModule.forFeature([OptiEffects]),
    SortableColumnModule
  ],
  exports: [
    OptiListComponent,
    OptiEditComponent,
    OptiProdComponent,
    ProductionPlanningComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    SortableColumnModule
  ]
})
export class OptiModule {
  constructor(
  ) {}

}
